import { StyleSheet } from 'aphrodite/no-important';
import { POSITION, COLORS, FONTS, MEDIA_QUERIES } from '../styles';

export default StyleSheet.create({
  section: {
    position: POSITION.RELATIVE,
    padding: '80px 20px 100px',
    background: COLORS.WHITE,
    textAlign: 'center',

    [MEDIA_QUERIES.MOBILE]: {
      padding: '40px 20px 60px',
    },
  },

  title: {
    position: POSITION.RELATIVE,
    display: 'inline-block',
    ...FONTS.RAMA_E,
    fontSize: 36,
    fontWeight: 400,
    padding: '10px',
    marginBottom: 40,
    textAlign: 'center',
    textTransform: 'uppercase',
    color: COLORS.WHITE,
    background: COLORS.PINK,

    [MEDIA_QUERIES.MOBILE]: {
      fontSize: 28,
    },
  },

  grid: {
    position: POSITION.RELATIVE,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'stretch',
    maxWidth: 1200,
    margin: '0 auto',
    gap: 24,
    padding: '0 10px',

    [MEDIA_QUERIES.MOBILE]: {
      gap: 16,
    },
  },

  item: {
    flex: '1 1 300px',
    maxWidth: 360,
    minWidth: 280,
    minHeight: 500,
    maxHeight: 500,
    overflow: 'hidden',
    textAlign: 'center',
  },

  embed: {
    width: '100%',
    minHeight: 500,
    maxHeight: 500,
    margin: 0,
    border: 0,
    background: COLORS.GRAY4,
  },
});
